import { Observable, of } from 'rxjs';
import { PartialRecord } from '../../records/entities/partial-record.class';
import { ShAbstractRecordDownloadService } from './abstract-record-download.service';

export class ShRecordDownloadService implements ShAbstractRecordDownloadService {
    getDownloadUrlForAccessRepresentation(record: PartialRecord): Observable<string | null> {
        const pathToPreview = record.metadata?.Internal?.PathToPreview;
        if (pathToPreview == undefined) {
            return of(null);
        }
        return of(pathToPreview);
    }
}
